export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Best in BlockChain News & Tech',
  headline: 'Advanced digital asset tracking.',
  description:
    'Application that provides you with the latest in updates with crypto currency data.',
  buttonLabel: 'Get Started',
  imgStart: '',
  img: require('../../images/svg-1.svg'),
  alt: 'Credit Card',
  start: ''
};

export const homeObjTwo = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Instant Setup',
  headline: 'Rapid and responsive dashboard system.',
  description:
    "Dashboard can provide insight into where the current crypto is predicted to go according to market fluctuations.",
  buttonLabel: 'Learn More',
  imgStart: '',
  img: require('../../images/svg-2.svg'),
  alt: 'Vault',
  start: ''
};

export const homeObjThree = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Albert Einstein',
  headline:
    'Crypto wiki is unreal.',
  description:
    "Awesome collaborative enviroment. It gave me valuable insight on the crypto-currency that I currently hold as well as new values stepping into the market.",
  buttonLabel: 'Show Me the Research',
  imgStart: 'start',
  img: require('../../images/albert.jpg'),
  alt: 'Vault',
  start: 'true'
};

export const homeObjFour = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Secure Database',
  headline: 'All your data is stored on a private secure server',
  description:
    'You will never have to worry about your information getting leaked.',
  buttonLabel: 'Sign Up Now',
  imgStart: 'start',
  img: require('../../images/svg-3.svg'),
  alt: 'Vault',
  start: 'true'
};
